import { type IWithdrawRequestContext, WithdrawRequestContext } from 'BreetComponents';
import { useContext } from 'react';

export const useWithdrawRequestContext = (): IWithdrawRequestContext => {
	const withdrawRequestContext = useContext(WithdrawRequestContext);

	if (!withdrawRequestContext) {
		throw new Error('useWithdrawRequestContext must be used within a WithdrawRequestProvider');
	}

	return withdrawRequestContext;
};
